import { render, staticRenderFns } from "./FuComplexInputNumber.vue?vue&type=template&id=72f4b398&"
import script from "./FuComplexInputNumber.vue?vue&type=script&lang=js&"
export * from "./FuComplexInputNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports